import "bootstrap/dist/css/bootstrap.min.css";
import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import caixaAssistencia from '../images/caixa_assistencia.png';
import rapidex from '../images/rapidex.png';

export default function PesquisaPage() {
    const navigate = useNavigate();

    return (
        <>
        <div className="d-flex flex-column w-100 align-items-center h-full">
            <div className="d-flex flex-column bg-padrao align-items-center h-full" style={{width: "1150px"}}>
                <div className="d-flex flex-row justify-content-between w-100">
                    <div style={{marginLeft: "10px", marginTop: "10px"}}>
                        <img src={rapidex} alt=""></img>
                    </div>
                    <img src={caixaAssistencia} alt=""></img>
                </div>

                <div className="d-flex flex-row w-100 justify-content-center" style={{marginTop: "300px"}}>
                    <button className="btn btn-primary p-3" style={{width: "300px", marginRight: "10px"}} onClick={() => window.location.href='https://acompanhamento.caixaassistencia.com.br/'}>Acompanhamento de vendas</button>
                    <button className="btn btn-primary p-3" style={{width: "300px"}} onClick={() => navigate("/pesquisa_filtro")}>Atualizar ou pesquisar propostas</button>
                </div>

                <div className="d-flex flex-column align-items-center" style={{marginTop: "50px"}}>
                    <div style={{marginTop: "30px"}}>
                        <span className="chat_apoio">Chat de Apoio à Rede</span>
                    </div>
                    <div>
                        <span className="chat_apoio_parceira">Chat de Apoio à Rede Caixa e Rede Parceira</span>
                    </div>
                    <div>
                        <button className="botao_chat_online" onClick={() => window.location.href='https://atendimentolojista.caixaassistencia.com.br/'}>Chat Online</button>
                    </div>
                </div>

            </div>
        </div>
        </>
    )
}
